// components/Login.js

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { Formik } from 'formik';

import {
  Box,
  Button,
  Container,
  Grid,
  TextField,
  Typography
} from '@material-ui/core';
// import FacebookIcon from 'icons/Facebook';
// import GoogleIcon from 'icons/Google';
import { BaseUrl, endpoints, setLocalStorage } from '../utils/factory';
import axios from 'axios';


const Login = () => {
  const [loginmsg, setLoginMsg] = useState('');

  const navigate = useNavigate();

  const handlelogin = async (values) => {
    try {
      const response = await axios.post(
        `${BaseUrl}${endpoints.login}`,
        {
          email: values.email,
          password: values.password,
          qtype: '1',
          cmp_id: '' 
        }
      );

      const data = response.data;

      if (data.message === 'Login successful') {
        const userdata = data.user;

        setLocalStorage('tranuserid', userdata.usr_name);
        setLocalStorage('trans-userName',userdata.usr_name);
        setLocalStorage('trans-userId',userdata.sno);
        setLocalStorage('trans-cmp_id',userdata.cmp_id);
        navigate('/app/delivery-list', { replace: true });
        setLoginMsg('');
      } else {
        setLoginMsg('Invalid Credentials');
      }
    } catch (error) {
      console.log('API error', error);
      if (error.response && error.response.status === 401) {
        setLoginMsg('Invalid Credentials');
      } else {
        setLoginMsg('An error occurred. Please try again.');
      }
    }
  };

  const readData = async () => {
    const clientid = localStorage.getItem('tranuserid');
    if (clientid && clientid !== '') {
      navigate('/app/delivery-list', { replace: true });
    }
  };

  useEffect(() => {
    readData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet>
        <title>Login</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              email: '',
              password: ''
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string().required('User ID is required'),
              password: Yup.string().max(255).required('Password is required')
            })}
            onSubmit={(values) => {
              handlelogin(values);
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box sx={{ mb: 3 }}>
                  <Typography color="textPrimary" variant="h2">
                    Sign in
                  </Typography>
                  <Typography
                    color="textSecondary"
                    gutterBottom
                    variant="body2"
                  >
                    Sign in on the internal platform
                  </Typography>
                </Box>
                <Box
                  sx={{
                    pb: 1,
                    pt: 3
                  }}
                >
                  {loginmsg !== '' && (
                    <Typography
                      align="center"
                      color="error"
                      variant="body1"
                    >
                      {loginmsg}
                    </Typography>
                  )}
                </Box>
                <TextField
                  error={Boolean(touched.email && errors.email)}
                  fullWidth
                  helperText={touched.email && errors.email}
                  label="User ID"
                  margin="normal"
                  name="email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="text"
                  value={values.email}
                  variant="outlined"
                />
                <TextField
                  error={Boolean(touched.password && errors.password)}
                  fullWidth
                  helperText={touched.password && errors.password}
                  label="Password"
                  margin="normal"
                  name="password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="password"
                  value={values.password}
                  variant="outlined"
                />
                <Box sx={{ py: 2 }}>
                  <Button
                    color="primary"
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Sign in now
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Box>
    </>
  );
};

export default Login;
